export const footerContactArray = [
    {
        link: "https://twitter.com",
        icon: 'fa fa-twitter',
        title: 'Twitter',
    },
    {
        link: "https://www.facebook.com/profile.php?id=100014321836619&sk=about",
        icon: 'fa fa-facebook',
        title: 'Facebook',
    },
    {
        link: "https://t.me/ComeThroughDontLinger",
        icon: 'fa fa-telegram',
        title: 'Telegram',
    },
]

export const footerLinkArray = ['FAQs', 'Give us feedback', 'Contact us']
export const footerMenu = ['Get in touch', 'About movie star', 'Legal stuff'];